import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { indexProjects, IndexProjectsAction } from 'src/actions/project/index/IndexProjects.actions';
import Project from 'src/entities/Project';
import ProjectListComponent from './ProjectList.component';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import * as moment from 'moment';

interface StateProps {
  projects?: Project[];
}

interface DispatchProps {
  indexProjects: (key: string, status?: string, limit?: number) => Promise<IndexProjectsAction>;
}

interface OwnProps {
  status: string;
  limit?: number;
  isSimple: boolean;
  listKey: string;
  carousel?: boolean;
  numberOfItems?: number;
  onLoadProjects?: () => void;
}

interface Props extends StateProps, DispatchProps, OwnProps {
}

class ProjectListContainer extends React.Component<Props> {

  static defaultProps = {
    carousel: false,
    numberOfItems: 0
  };

  constructor(props: Props) {
    super(props);
    this.props.indexProjects(this.props.listKey, this.props.status, this.props.limit).then(() => {
      if (this.props.onLoadProjects) {
        this.props.onLoadProjects();
      }
    });
  }

  public render(): React.ReactNode {
    let openProjects: Project[] = [];
    if (this.props.projects && this.props.status === 'open') {
      openProjects = this.props.projects
        .filter((project) => {
          if ((moment.utc(project.endDate, 'YYYY-MM-DD').diff(moment(moment()), 'days') < 0) &&
            ((project.cash / project.cashTarget * 100) < 90)) {
            return;
          } else {
            return project;
          }
        });
    } else if (this.props.projects && this.props.projects.length) {
      openProjects = this.props.projects;
    }
    
    return (
      openProjects ? (
          <ProjectListComponent
            projects={openProjects}
            isSimple={this.props.isSimple}
            carousel={this.props.carousel!}
            numberOfItems={this.props.numberOfItems!}
            status={this.props.status}
          />
        ) :
        <LoadingContainer/>
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    indexProjects: (key: string, status?: string, limit?: number): Promise<IndexProjectsAction> => {
      return dispatch(indexProjects(key, status, limit));
    }
  };
};

const mapStateToProps: (state: RootState, ownProps: OwnProps) => StateProps = (state: RootState, ownProps: OwnProps):
  StateProps => ({
  projects: state.indexProjects.projectsLists[ownProps.listKey]
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectListContainer);



// WEBPACK FOOTER //
// ./src/modules/projects/ProjectList.container.tsx